import { CheckBadgeIcon } from "@heroicons/react/24/outline";
import { Button } from "../../components/ui/Button";

const Success = () => {
    return (
        <div className="min-h-screen bg-canvas font-sans flex items-center justify-center px-6 py-24">
            <div className="max-w-lg w-full rounded-2xl border border-border bg-surface shadow-card px-8 py-12 text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 mb-6 rounded-full bg-success-subtle">
                    <CheckBadgeIcon className="text-success w-9 h-9" />
                </div>
                <h1 className="font-display text-4xl md:text-5xl font-normal tracking-tight leading-tight text-ink mb-6">
                    Payment Successful!
                </h1>
                <p className="text-lg leading-relaxed text-ink-muted max-w-xl mx-auto mb-8">
                    Thank you for your purchase. Your transaction has been
                    completed. You can now access all the features of your
                    subscription.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={() => (window.location.href = "/dashboard")}
                    >
                        Go to Dashboard
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Success;
